<div class="lead-form-container container-form">
    <!--Options-->
    <div class="row container-form-options" *ngIf="isShowOptions">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="saveClick()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
                <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content">
        <div class="col-12">
            <sgt-lead-form-info
                #leadFormInfo
                *ngIf="readonly">
            </sgt-lead-form-info>
                        
            <sgt-lead-form
                *ngIf="!readonly"
                #leadForm
                [isMini]="isMini"
                [isShowUsuarioResponsavel]="isShowUsuarioResponsavel"
                [isShowTemperatura]="isShowTemperatura"
                (cancel)="cancel()">
            </sgt-lead-form>
        </div>
    </div>
</div>
